import * as Yup from 'yup';
import multiPaymentSchema from '@payments/sectionsMethodsPayment/MultiPayments/schema';

export const schema = Yup.object().shape({
  ...multiPaymentSchema,
});
